import { API_ROUTE_ADMIN_EXPORTS } from '@/resources/api-routes'
import { getBinary } from '@/util/auth'

import type { ExportFiltersType } from './types'

export const getBinaryExports = async ({
  reportName,
  toDate,
  fromDate,
  isGlobal,
  countryId,
  formatName,
  customerId,
}: ExportFiltersType) => {
  const searchParams = new URLSearchParams()

  searchParams.append('fromDate', fromDate)
  searchParams.append('toDate', toDate)
  searchParams.append('reportName', reportName)

  searchParams.append('isGlobal', isGlobal.toString())
  searchParams.append('countryId', countryId.toString())

  if (customerId) {
    searchParams.append('customerId', customerId.toString())
  }

  const url = `${API_ROUTE_ADMIN_EXPORTS}?${searchParams.toString()}&exportFormat=${formatName}`

  const result = await getBinary(url)

  return result
}
